import React, { useState, useEffect } from "react";
import { Form, Input, Button, Checkbox } from "antd";
import axios from "axios";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
// import { appActions } from "../Store/store";
import { useNavigate, Link, Navigate } from "react-router-dom";
import "./login.css";
// import surveyorIcon from "./surveyorIcon.png";
// import illustration from "./login_img.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import styled from "styled-components";
import {
	StyledInput,
	StyledPasswordInput,
} from "../login-module/customComponents/styled_input";
const UserType = () => {
	const StyledCheckBox = styled(Checkbox)`
   border-radius:0px;
   font-family: 'Montserrat', sans-serif;
  &.ant-checkbox-wrapper {
  
    .ant-checkbox-inner {
    
      border-color: lightgrey !important; /* Default border color */
    }

    &:hover .ant-checkbox-inner {
      border-color: #f04ca4 !important; /* Border color on hover */
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #f04ca4 !important; /* Background color when checked */
      border-color: #f04ca4 !important; /* Border color when checked */
    }

    &:hover .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #FF0083 !important; /* Background color when checked and hovered */
      border-color: #FF0083 !important; /* Border color when checked and hovered */
    }

    .ant-checkbox-inner:active {
      border-color: #FF0083 !important; /* Border color when active (clicked) */
    }

    .ant-checkbox-checked .ant-checkbox-inner:active {
      background-color: #FF0083 !important; /* Background color when checked and active */
      border-color: #FF0083 !important; /* Border color when checked and active */
    }

    .ant-checkbox-checked .ant-checkbox-inner::after {
      border-color: white !important; /* Checkmark color */
    }

    &:hover .ant-checkbox-checked .ant-checkbox-inner::after {
      border-color: white !important; /* Checkmark color on hover */
    }
  }

`;

	const navigate = useNavigate();
	const surveyorIcon = `${process.env.PUBLIC_URL}/custom-icons/surveyorIcon.png`;
	const orIcon = `${process.env.PUBLIC_URL}/or.svg`;
	const illustration = `${process.env.PUBLIC_URL}/custom-icons/login_img.png`;

	const agentOnClickHandler = () => {
		navigate("/login");
	}
	const userOnClickHandler = () => {
		navigate("/inputLink");
	}

	const [link, setLink] = useState("");
	const [validLink, setValidLink] = useState(true);
	// const navigate = useNavigate();

	const onChangeHandler = (e) => {
		const newValue = e.target.value;
		setLink(newValue);
		console.log("Input value:", newValue);
	};
	const onClose = (e) => {
		console.log(e, 'I was closed.');
	};

	const onClickHandler = () => {
		const urlPattern = /https?:\/\/[^\/]+(\/.*)$/;
		const match = link.match(urlPattern);
		if (match) {
			setValidLink(true)
			const path = match ? match[1] : '';
			navigate(path)
			console.log(path, "path");
		}
		else {
			alert("Enter a valid URL");
			setValidLink(false)
		}
		console.log("Proceed with link:", link);
	};

	return (
		<div className="responsive-login-container">
			<div className="login-illustration">
				<LazyLoadImage alt="Illustration" effect="opacity" src={illustration} />
			</div>
			<div className="login-form-container">
				<LazyLoadImage
					src={surveyorIcon}
					alt="Surveyor's AI"
					className="surveyor-icon"
					effect="opacity"
				/>
				<Button
					onClick={agentOnClickHandler}
					style={{
						backgroundColor: "#FF0083",
						color: "#FFFFFF",
						minHeight: "40px",
						width: "130px",
						marginBottom: "10px",
					}}
				>
					Login
				</Button>


			</div>
		</div>
	);
};

export default UserType;
